import { Chip as HeroUiChip } from '@heroui/react';
import { type FC, memo } from 'react';

type ChipProps = {
    children: React.ReactNode;
    onClose: () => void;
    className?: string;
};

export const Chip: FC<ChipProps> = memo(({ children, onClose, className }) => (
    <HeroUiChip
        variant="solid"
        size="md"
        onClose={onClose}
        classNames={{
            base: 'bg-slate-grey-50 text-slate-grey',
            closeButton: '*:*:bg-slate-grey opacity-100 hover:opacity-70 *:h-[19.5px] *:w-[19.5px]',
        }}
        className={className}
    >
        {children}
    </HeroUiChip>
));
